import { useState, useEffect, useRef } from "react";
import searchicon from "../../Assets/Navbaricons/Search.svg";
import DownArrow from "../../Assets/Navbaricons/DownArrow.svg";
import Options from "../Modals/AccountModal/AccountModal";
// import hyprcomIcon from "../../Assets/hyprcomIcon.png";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../Features/searchSlice";
import Modal from "./Components/Modal";
import { useLocation } from "react-router-dom";
import Bell from "./Components/Bell.js";
import { formatUserName, getInitials } from "../../lib/utils/utils.js";
import { useOutsideClickForTwoRef } from "../../Hooks/useOutsideClickForTwoRef.js";
import { closeModal } from "../../Features/notificationsSlice.js";

export default function Navbar() {
    const [isOptionsOpen, setIsOptionsOpen] = useState(false);
    const [optionsAnchorEl, setOptionsAnchorEl] = useState(null);
    const [unreadCount, setUnreadCount] = useState(0);

    const dispatch = useDispatch();
    const location = useLocation();

    const bellButtonRef = useRef(null);
    const modalRef = useRef(null);

    useOutsideClickForTwoRef(modalRef, bellButtonRef, () => {
        dispatch(closeModal());
    });

    const modalDisplay = useSelector((state) => state.notifications.modalDisplay);
    const user = useSelector((state) => state.user.user);
    const notifications = useSelector((state) => state.notifications.notifications.notifications);

    const handleMouseEnter = (e) => {
        e.stopPropagation();
        dispatch(openModal());
        setTimeout(() => {
            e.target.blur();
        }, 10);
    };

    useEffect(() => {
        const count = notifications.filter(
            (notification) => !notification.readStatus
        ).length;
        setUnreadCount(count);
    }, [notifications]);

    const handleOpenOptions = (event) => {
        setOptionsAnchorEl(event.currentTarget);
        setIsOptionsOpen(true);
    };

    return (
        <>
            <div className="w-full flex items-center justify-between border-b border-[#E5E7EB]">
                <div className="flex flex-grow gap-3 items-center justify-center px-3 py-[9px] ">
                    <img src={searchicon} alt="search" className="searchIcon" />

                    <input
                        type="text"
                        placeholder="Search"
                        id="search"
                        autoComplete="off"
                        className="w-full py-[13px] text-[#666666] text-[16px] outline-none"
                        onMouseDown={handleMouseEnter}
                    />
                </div>

                <div className="w-fit flex items-center justify-end gap-4 mr-5">
                    {/* <div className="relative flex items-center justify-center size-8">
                        <Bell 
                            boxRef={bellButtonRef} 
                        />

                        {
                            location.pathname === "/notifications" ? null : 
                            !modalDisplay &&
                                unreadCount > 0 && (
                                <div className="absolute size-6 flex items-center justify-center left-1/2 bottom-4 bg-primaryColor rounded-full">
                                    <h2 className="select-none font-semibold text-[10px] leading-[14px] text-buttonText">
                                        {unreadCount > 99 ? "99+" : unreadCount}
                                    </h2>
                                </div>
                            )
                        }

                        <Modal 
                            boxRef={modalRef} 
                        />
                    </div> */}

                    <div className="font-mulish w-fit flex items-center gap-2 p-[9px_0px_9px_10px]" onClick={(event) => handleOpenOptions(event)}>
                        <div className="cursor-pointer flex items-center justify-center w-[46px] h-[46px] bg-[#EAEAEA] rounded-full relative text-[16px] font-bold leading-6 text-[#666]">
                            {
                                user?.profilePic ? 
                                (
                                    <img
                                        src={user?.profilePic}
                                        alt=""
                                        className="w-[46px] h-[46px] rounded-full"
                                    />
                                ) : 
                                (
                                    user?.name && <span>{getInitials(user.name)}</span>
                                )
                            }
                        </div>

                        <div className="flex flex-col">
                            <div className="text-[14px] text-nowrap font-bold leading-6 relative text-[#121212] text-left">
                                {formatUserName(user?.name)}
                            </div>

                            <div className="accountAccess">{user?.role}</div>
                        </div>

                        <div className="w-[26px] h-6 p-[6px] gap-[10px]">
                            <img
                                className="w-[14px] h-3 cursor-pointer"
                                src={DownArrow}
                                alt="DownArrow"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {isOptionsOpen && (
                <Options
                    open={isOptionsOpen}
                    onClose={() => setIsOptionsOpen(false)}
                    anchorEl={optionsAnchorEl}
                    email={user.email}
                    name={user.name}
                    file={user.profilePic}
                />
            )}
        </>
    );
}
